import {Component, inject, OnInit} from '@angular/core';
import {OwlOptions} from "ngx-owl-carousel-o";
import {CarouselComponent} from "../../../assets/shared/components/carousel/carousel.component";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {PaymentService} from "../../core/services/payment/payment.service";
import {Carousel} from "../../core/interface/carousel";

@UntilDestroy()
@Component({
  selector: 'look-payment',
  imports: [
    CarouselComponent,
  ],
  standalone: true,
  templateUrl: './look-payment.component.html',
  styleUrl: './look-payment.component.scss'
})
export class LookPaymentComponent implements OnInit {
  private paymentService = inject(PaymentService);
  carouselInfo: Carousel[] | undefined
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navText: [
      '<img src="assets/images/ul-kit/left-arrow.svg">',
      '<img src="assets/images/ul-kit/right-arrow.svg">'
    ],

    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    },
    nav: true
  }

  ngOnInit() {
    this.getCarouselInfo();
  }

  getCarouselInfo(){
    this.paymentService.getCarouselInfo('carouselThanks').pipe(untilDestroyed(this)).subscribe(carousel => {
      this.carouselInfo = carousel
    })
  }


}


